import script from "./UTagInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UTagInput.vue?vue&type=script&setup=true&lang=js"

import "./UTagInput.vue?vue&type=style&index=0&id=327685ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327685ea"]])

export default __exports__